<div class="quiz-card" *ngIf="cardData">
  <div class="card-time" brtRoughText [type]="'circle'" [state]="current ? 'run' : 'stop'" *ngIf="cardData.time.length">{{cardData.time}} Uhr</div>
  <div class="quiz-card__title">
    <span>{{ "INSIGHTS.QUIZ_TITLE" | translate:{PROFESSION_NAME: cardData.title} }}</span>
  </div>


  <div class="quiz-card__animation" *ngIf="cardData.lottieAnimation"><brt-lottie [lottieOptions]="{autoplay: false, loop: true, path: cardData.lottieAnimation}" (instanceCreated)="onAnimationCreated($event)"></brt-lottie></div>

  <a [href]="cardData.text" target="_blank" class="quiz-card__link">
    <brt-button [title]="'Zu den Quizfragen'" [color]="'river'" [size]="'large'"></brt-button>
  </a>
</div>
